import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = (r => {
  return r.keys().map(key => r(key).default)
})(require.context('./', true, /^\.\/pages\/((?!\/)[\s\S])+\/config\.js$/)).filter(route => {
  if (!route.meta.expireIn) {
    return true
  }
  return new Date(route.meta.expireIn).getTime() > new Date().getTime()
})
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const bodyClassList = document.body.classList
router.beforeEach((to, from, next) => {
  let clientWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth || window.screen.width
  window.clientWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth || window.screen.width
  const designWidth = to.meta.designWidth
  window.remWidth = clientWidth
  bodyClassList.add('loading')

  document.documentElement.style.fontSize = 100 * clientWidth / designWidth + 'px'

  document.title = to.meta.title
  next()
})

router.afterEach(() => {
  setTimeout(() => {
    bodyClassList.remove('loading')
  }, 200)

  window.scrollTo(0, 0)
})

export default router
